import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Powrót do poprzedniego widoku.
 *
 * **Historia, nie hierarchia** — i to jest rozstrzygnięcie. Raport czterech
 * kolumn otwiera się z dwóch miejsc: z ekranu produkcji i z portfela. Powrót
 * po stałej ścieżce („zawsze do produkcji") odsyłałby w połowie przypadków
 * gdzie indziej niż tam, skąd użytkownik przyszedł — a to jest gorsze niż
 * brak przycisku, bo wygląda na usterkę nawigacji.
 *
 * Historia ma jednak dziurę: gdy ktoś wszedł tu z zakładki albo z wklejonego
 * odsyłacza, cofnięcie wyprowadza z aplikacji. Rozpoznajemy to po
 * ``location.key``, które dla pierwszego wpisu w historii karty ma wartość
 * ``"default"``; wtedy zamiast cofać, idziemy do widoku nadrzędnego.
 */
export function BackButton({ fallback }: { fallback: string }) {
  const nawiguj = useNavigate();
  const lokalizacja = useLocation();
  const jestDokad = lokalizacja.key !== "default";

  return (
    <Tooltip title={jestDokad ? "Wróć do poprzedniego widoku" : "Wróć"}>
      <IconButton
        size="small"
        aria-label="Wróć"
        onClick={() => (jestDokad ? nawiguj(-1) : nawiguj(fallback))}
        sx={{ ml: -0.5 }}
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
